import { CANONICAL_LOADING_MESSAGES } from "./types";

export interface IdentityLoadingProps {
  message: keyof typeof CANONICAL_LOADING_MESSAGES | string;
}

export function IdentityLoading({ message }: IdentityLoadingProps) {
  const text =
    message in CANONICAL_LOADING_MESSAGES
      ? CANONICAL_LOADING_MESSAGES[message as keyof typeof CANONICAL_LOADING_MESSAGES]
      : message;
  return (
    <div className="sc-identity-loading" role="status" aria-live="polite">
      <span className="sc-identity-spinner" aria-hidden />
      <span>{text}</span>
    </div>
  );
}
